export const AccessStatus = {
    PENDING: 'pending',
    SCHEDULED: 'scheduled',
    RESTRICTED: 'restricted',
    ALLOWED: 'allowed'
};

// Firestore timestamps show up in two shapes depending on where they came from -
// the client SDK gives { seconds }, data that's been through a REST/Cloud Function
// hop gives { _seconds }. Accept either so access_begins/access_expires checks
// don't silently break depending on the source.
export const getTimestampSeconds = timestamp => {
    if (!timestamp) return null;
    if (typeof timestamp.seconds === 'number') return timestamp.seconds;
    if (typeof timestamp._seconds === 'number') return timestamp._seconds;
    return null;
};

// Single source of truth for the "Access ..." status label + color shown in
// MemberDetails.jsx and NewVisitor.jsx - keep these in sync between both.
export const ACCESS_STATUS_META = {
    [AccessStatus.PENDING]: {
        label: 'Access Pending',
        color: 'rgba(202, 138, 4, 1)'
    },
    [AccessStatus.SCHEDULED]: {
        label: 'Access Scheduled',
        color: 'rgba(37, 99, 235, 1)'
    },
    [AccessStatus.RESTRICTED]: {
        label: 'Access Restricted',
        color: 'rgba(230, 58, 58, 1)'
    },
    [AccessStatus.ALLOWED]: {
        label: 'Access Allowed',
        color: 'rgba(22, 163, 74, 1)'
    }
};

// Priority order: a pending invite beats everything else, then a schedule
// that hasn't started yet, then an explicit restriction, else access is allowed.
export const getAccessStatus = ({ pending, scheduled, restricted }) => {
    if (pending) return AccessStatus.PENDING;
    if (scheduled) return AccessStatus.SCHEDULED;
    if (restricted) return AccessStatus.RESTRICTED;
    return AccessStatus.ALLOWED;
};
